import LazyLoad from "vanilla-lazyload";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import zenscroll from "zenscroll";
// import Marquee3k from "marquee3000";
import { Loader } from "@googlemaps/js-api-loader";
import hoverintent from "hoverintent";

gsap.registerPlugin(ScrollTrigger);

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const html = document.querySelector("html");
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
const container = document.querySelector(".container");
const scrollContainer = document.querySelector(".scroll-container");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
const overlayFull = document.getElementById("overlay_full");
const overlayInner = document.querySelector("#overlay_full .inner");
const overlayCloser = document.querySelector("#overlay_full .closer");
const library = document.getElementById("library");
let frameThumbs = document.querySelectorAll(".frame_thumbs .cell");

window.onload = (event) => {
  body.classList.remove("preload");

  // ON PAGE LOAD CHECK FOR SCROLL_COLS AND STAGGER ON READY CLASS
  let scrollColsCheck = document.querySelector(".scroll_cols");
  if (typeof scrollColsCheck != "undefined" && scrollColsCheck != null) {
    setTimeout(function () {
      scrollColsCheck.querySelector(".col1").classList.add("ready");
    }, 150);
    setTimeout(function () {
      scrollColsCheck.querySelector(".col2").classList.add("ready");
    }, 250);
    setTimeout(function () {
      scrollColsCheck.querySelector(".col3").classList.add("ready");
    }, 300);
  }
};

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  /* SCROLL COLS IN MOBILE NEEDS JS TO MOVE EVERYTHING INTO SINGLE COLUMN IN ORDER */

  let scrollColsCheck = document.querySelector(".scroll_cols");
  if (
    typeof scrollColsCheck != "undefined" &&
    scrollColsCheck != null &&
    innerWidth <= 1023
  ) {
    // get all items, sort by data count attribute
    let scrollCellItems = scrollColsCheck.querySelectorAll(".cell");
    let scrollCellItemsArray = Array.from(scrollCellItems);
    let scrollCellItemsSorted = scrollCellItemsArray.sort(function (a, b) {
      return +a.dataset.count - +b.dataset.count;
    });

    // loop through sorted array and insert into dom
    scrollCellItemsSorted.forEach((item) => {
      scrollColsCheck.querySelector(".col1").append(item);
    });
  }

  // check for any hover_slideshow elements and setup Flickity slideshow
  var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= innerHeight * 0.2 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight * 0.8 ||
          document.documentElement.clientHeight * 0.8) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  let hoverSlideshows = document.querySelectorAll(".hover_slideshow");
  hoverSlideshows.forEach((hoverSlideshow) => {
    let hoverFlickity = new Flickity(hoverSlideshow, {
      // options
      fade: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      pauseAutoPlayOnHover: false,
      draggable: false,
      autoPlay: 1000,
      initialIndex: 1,
    });

    // pause player by default
    hoverFlickity.pausePlayer();

    // for desktop slideshow is triggered on hover, autoplay on mobile
    if (innerWidth > 932) {
      // on mouseover add active class and start slideshow
      hoverSlideshow.addEventListener("mouseover", function () {
        hoverSlideshow.classList.add("active");
        hoverFlickity.playPlayer();
      });

      hoverSlideshow.addEventListener("mouseleave", function () {
        hoverSlideshow.classList.remove("active");
        hoverFlickity.pausePlayer();
      });
    } else {
      // before scroll starts, check position
      if (isInViewport(hoverSlideshow)) {
        hoverFlickity.playPlayer();
      } else {
        hoverFlickity.pausePlayer();
      }

      // listener on scroll
      window.addEventListener(
        "scroll",
        function (event) {
          if (isInViewport(hoverSlideshow)) {
            hoverFlickity.playPlayer();
          } else {
            hoverFlickity.pausePlayer();
          }
        },
        false
      );
    }
  });

  /* CHECK FOR HOMEPAGE, TRIGGER MENU OPEN AFTER SMALL DELAY */

  let homePageCheck = document.getElementById("home");
  if (
    homePageCheck != "undefined" &&
    homePageCheck != null &&
    innerWidth > 896
  ) {
    setTimeout(function () {
      menuBtn.click();
    }, 1500);
  }

  /* GSAP PAGE SCROLL */

  var scroller = {
    target: document.querySelector("#scroll-container"),
    ease: 0.1, // <= scroll speed
    endY: 0,
    y: 0,
    resizeRequest: 1,
    scrollRequest: 0,
    active: true,
  };

  var requestId = null;

  let smoothScroll = gsap.set(scroller.target, {
    rotation: 0.01,
    force3D: true,
  });

  function killScroller() {
    scroller.active = false;
  }

  window.addEventListener("load", onLoad);

  function onLoad() {
    if (window.innerWidth > 1024) {
      if (body.classList.contains("nonav")) {
        return;
      }
      if (
        typeof document.querySelector("#scroll-container") != "undefined" &&
        document.querySelector("#scroll-container") != null
      ) {
        updateScroller();
        window.focus();
        window.addEventListener("resize", onResize);
        document.addEventListener("scroll", onScroll);
      }
    }
  }

  function updateScroller() {
    if (scroller.active) {
      var resized = scroller.resizeRequest > 0;

      if (resized) {
        var height = scroller.target.clientHeight;
        body.style.height = height + "px";
        scroller.resizeRequest = 0;
      }

      var scrollY = window.pageYOffset || html.scrollTop || body.scrollTop || 0;

      scroller.endY = scrollY;
      scroller.y += (scrollY - scroller.y) * scroller.ease;

      if (Math.abs(scrollY - scroller.y) < 0.05 || resized) {
        scroller.y = scrollY;
        scroller.scrollRequest = 0;
      }

      smoothScroll = gsap.set(scroller.target, {
        y: -scroller.y,
      });

      requestId =
        scroller.scrollRequest > 0
          ? requestAnimationFrame(updateScroller)
          : null;
    }
  }

  function onScroll() {
    scroller.scrollRequest++;
    if (!requestId) {
      requestId = requestAnimationFrame(updateScroller);
    }
  }

  function onResize() {
    scroller.resizeRequest++;
    if (!requestId) {
      requestId = requestAnimationFrame(updateScroller);
    }
  }

  // check for #library div to create cols
  if (typeof library != "undefined" && library != null) {
    createCols();
  }

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  /* GOOGLE MAPS WHERE TO BUY FUNCTIONS */

  let wtbPage = document.querySelector(".wtb_map");
  if (typeof wtbPage != "undefined" && wtbPage != null) {
    const apiOptions = {
      apiKey: "AIzaSyCQqirtchvM-lGoGKY-sqDyWNdwextyhkU",
      libraries: ["places"],
    };

    let mapLoaded = false;
    let zoomLevel = 5;
    if (innerWidth <= 1023) {
      zoomLevel = 12;
    }
    const loader = new Loader(apiOptions);

    loader.load().then(() => {
      const map = displayMap();
      const markers = addMarkers(map);
      const autocomplete = autoCompleteInit(map);
      const mapupdate = updatedMapInfo(map);
    });

    // handle mobile views click between list and map
    let viewsBtn = document.querySelectorAll(".views .btn");
    viewsBtn.forEach((viewBtn) => {
      viewBtn.addEventListener("click", function (e) {
        e.preventDefault();
        let view = viewBtn.getAttribute("data-view");
        let mapEl = document.querySelector(".wtb_map .column.map");
        let listEl = document.querySelector(".wtb_map .column.info #results");
        if (view === "map") {
          mapEl.style.display = "block";
          listEl.style.display = "none";
          document
            .querySelector(".views button[data-view='map']")
            .classList.remove("pinkbg");
          document
            .querySelector(".views button[data-view='list']")
            .classList.add("pinkbg");
        } else {
          mapEl.style.display = "none";
          listEl.style.display = "block";
          document
            .querySelector(".views button[data-view='map']")
            .classList.add("pinkbg");
          document
            .querySelector(".views button[data-view='list']")
            .classList.remove("pinkbg");
        }
      });
    });

    function updateList(lat, lng, country, radius) {
      getAjax(
        "/retailerList2023.php?lat=" +
          lat +
          "&lng=" +
          lng +
          "&country=" +
          country +
          "&radius=" +
          radius,
        function (data) {
          document.querySelector("#results").innerHTML = data;
        }
      );
    }

    function updateMakers(map, lat, lng, country, radius) {
      getAjax(
        "/retailerList2023_markers.php?lat=" +
          lat +
          "&lng=" +
          lng +
          "&country=" +
          country +
          "&radius=" +
          radius,
        function (data) {
          addMarkers(map, JSON.parse(data));
        }
      );
    }

    function updatedMapInfo(map, country) {
      if (!mapLoaded) {
        return;
      }
      map.addListener("idle", function () {
        let center = map.getCenter();
        let lat = center.lat();
        let lng = center.lng();
        let country = document
          .querySelector("body")
          .getAttribute("data-country");
        let radius = document.querySelector("body").getAttribute("data-radius");

        // get updated markers after map move
        updateMakers(map, lat, lng, null, radius);

        // update the result list after map move
        //updateList(lat, lng, country, radius);
      });
    }

    function autoCompleteInit(map) {
      // setup google places autocomplete
      const input = wtbPage.querySelector("#location");
      // only include city, state and countries in autocomplete results
      const options = {
        fields: [
          "address_components",
          "geometry",
          "icon",
          "name",
          "formatted_address",
        ],
        strictBounds: false,
        types: [],
      };

      const autocomplete = new google.maps.places.Autocomplete(input, options);

      // listen for place_changed event to get address results - code not used for now
      //autocomplete.addListener("place_changed", () => {

      // update search results based on click
      let searchBtn = document.getElementById("search_btn");
      searchBtn.addEventListener("click", function (e) {
        e.preventDefault();

        // default radius to 5 miles
        let radius = 5;
        const radiusEl = document.getElementById("radius");
        if (radiusEl.value > 0) {
          radius = radiusEl.value;
        }

        // set the user radius to body data attribute
        document.querySelector("body").setAttribute("data-radius", radius);

        const place = autocomplete.getPlace();
        if (!place.geometry) {
          // user entered the name of a place that was not suggested and pressed the Enter key, or the Place Details request failed.
          return;
        }
        // get country, lat and lng from address components
        let country = "";
        let lat = place.geometry.location.lat();
        let lng = place.geometry.location.lng();
        place.address_components.forEach((address_component) => {
          if (address_component.types.includes("country")) {
            country = address_component.short_name;
            // set the user country to the body data attribute
            document
              .querySelector("body")
              .setAttribute("data-country", country);
          }
        });

        // if place has geometry, center map on location
        if (place.geometry.viewport) {
          map.fitBounds(place.geometry.viewport);
        } else {
          map.setCenter(place.geometry.location);
        }

        zoomLevel = 11;
        if (innerWidth <= 1023) {
          zoomLevel = 13;
        }

        map.setZoom(zoomLevel);
        // hit the database to find retailers and get markers

        // get updated markers after map move
        updateMakers(map, lat, lng, null, radius);

        // update the result list after map move
        updateList(lat, lng, country, radius);
      });
    }

    const markers = [];
    function addMarkers(map, locations) {
      /*
      // clear any existing markers
      markers.forEach((marker) => {
        marker.setMap(null);
      });
      */
      const windows = [];

      for (const location in locations) {
        let infoWindow, contentString;
        const markerOptions = {
          map: map,
          position: locations[location].location,
          icon: {
            url: "/images/lae-map-marker.png",
            scaledSize: new google.maps.Size(28, 37),
          },
        };
        const marker = new google.maps.Marker(markerOptions);

        // Create an info window content
        contentString =
          '<div class="infoWindow">' +
          '<h2 class="name">' +
          locations[location].name +
          '</h2><div class="bodyContent">' +
          "<p>" +
          locations[location].address +
          " " +
          locations[location].address2 +
          "<br />" +
          locations[location].city +
          ", " +
          locations[location].state +
          " " +
          locations[location].zip +
          "</p>" +
          "</div>" +
          "</div>";

        // Create an info window
        infoWindow = new google.maps.InfoWindow({
          content: contentString,
        });

        // Add a click event listener to the marker to open the info window
        marker.addListener("click", function () {
          // close all info windows before opening the selected one.
          windows.forEach((window) => {
            window.close();
          });
          infoWindow.open(map, marker);
        });

        windows.push(infoWindow);
        markers.push(marker);
      }

      return markers;
    }

    function displayMap() {
      const mapOptions = {
        center: { lat: 39.8097343, lng: -98.5556199 },
        zoom: zoomLevel,
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#e9e9e9",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 17,
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 29,
              },
              {
                weight: 0.2,
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 18,
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#dedede",
              },
              {
                lightness: 21,
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#ffffff",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                saturation: 36,
              },
              {
                color: "#333333",
              },
              {
                lightness: 40,
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers: [
              {
                color: "#f2f2f2",
              },
              {
                lightness: 19,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#fefefe",
              },
              {
                lightness: 17,
              },
              {
                weight: 1.2,
              },
            ],
          },
        ],
      };
      const mapDiv = document.getElementById("map");
      const map = new google.maps.Map(mapDiv, mapOptions);

      // default to US locations with 3000 mile radius - this should be updated with user's location

      let defaultLat = 39.8097343;
      let defaultLng = -98.5556199;
      let defaultCountry = "US";
      let defaultRadius = 1500;

      if ("geolocation" in navigator) {
        // check if geolocation is supported/enabled on current browser
        navigator.geolocation.getCurrentPosition(
          function success(position) {
            defaultLat = position.coords.latitude;
            defaultLng = position.coords.longitude;
            defaultRadius = 100;
            document
              .querySelector("body")
              .setAttribute("data-country", defaultCountry);
            document
              .querySelector("body")
              .setAttribute("data-radius", defaultRadius);

            // get updated markers after map move
            updateMakers(map, defaultLat, defaultLng, null, defaultRadius);

            // update the result list after map move
            updateList(defaultLat, defaultLng, defaultCountry, defaultRadius);

            // if we get a user location, lets zoom in and center on that
            map.setCenter({ lat: defaultLat, lng: defaultLng });
            if (innerWidth <= 896) {
              map.setZoom(9);
            } else {
              map.setZoom(11);
            }
          },
          function error(error_message) {
            // for when getting location results in an error
            console.error(
              "An error has occured while retrieving location",
              error_message
            );

            // fallback to default in center of US, markers only
            document
              .querySelector("body")
              .setAttribute("data-country", defaultCountry);
            document
              .querySelector("body")
              .setAttribute("data-radius", defaultRadius);

            // get updated markers after map move
            updateMakers(map, defaultLat, defaultLng, null, defaultRadius);
          }
        );
      } else {
        document
          .querySelector("body")
          .setAttribute("data-country", defaultCountry);
        document
          .querySelector("body")
          .setAttribute("data-radius", defaultRadius);

        // get updated markers after map move
        updateMakers(map, defaultLat, defaultLng, null, defaultRadius);

        // update the result list after map move
        //updateList(defaultLat, defaultLng, defaultCountry, defaultRadius);
      }

      mapLoaded = true;

      return map;
    }
  }

  /* SCROLLING ANNOUNCEMENT TEXT */

  // let annoucementEl = document.getElementById("announcement");
  // if (typeof annoucementEl != "undefined" && annoucementEl != null) {
  //   Marquee3k.init({
  //     selector: "marquee3k",
  //     pausable: false,
  //   });
  // }s

  const marqueeItems = gsap.utils.toArray(" .marquee3k p");
  if (marqueeItems.length > 0) {
    const marqueeLoop = horizontalLoop(marqueeItems, {
      paused: false,
      repeat: -1,
      reversed: false,
    });
    gsap.to(marqueeItems, { opacity: 1 });
  }
  /*
  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }
  */

  function removeThumbActive() {
    frameThumbs.forEach((frameThumb) => {
      frameThumb.classList.remove("active");
    });
  }

  function loadFrame(frame) {
    let color = frame.getAttribute("data-color");
    /*
    // update colorway label
    let targetLabel = document.querySelector(".frame_info h2.colorway");
    targetLabel.innerHTML = color;
    */

    // update bottom frame thumbnail active state
    removeThumbActive();
    let targetThumb = document.querySelector(
      ".frame_thumbs .cell[data-color='" + color + "']"
    );
    targetThumb.classList.add("active");
  }

  function loadImageInit() {
    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    let quarterVp = (innerHeight / 4) * -1;
    const frameView = new LazyLoad({
      elements_selector: ".detailwrap .frames .cell",
      thresholds: quarterVp + "px 0px " + quarterVp + "px 0px",
      callback_enter: loadFrame,
    });
  }

  loadImageInit();

  /* HOME PAGE FRAME SLIDESHOWS */
  let homeSlideshow = document.querySelector(".home_slideshow");

  if (typeof homeSlideshow != "undefined" && homeSlideshow != null) {
    let flktyHome = new Flickity(homeSlideshow, {
      // options
      fade: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: true,
      autoPlay: 4000,
      pauseAutoPlayOnHover: false,
    });
  }

  /* DETAIL PAGE MAIN FRAME SLIDESHOWS */
  let frameSlideshowEls = document.querySelectorAll(".cell .frame_slideshow");
  frameSlideshowEls.forEach((frameSlideshowEl) => {
    let dragSlides = true;
    if (frameSlideshowEl.classList.contains("with_360")) {
      dragSlides = false;
    }

    let frameSlideshow = new Flickity(frameSlideshowEl, {
      // options
      cellSelector: ".slide",
      fade: false,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: false,
      draggable: dragSlides,
    });

    /*
    // handle arrow clicks
    let nextArrow = frameSlideshowEl.querySelector(".arrow.next");
    nextArrow.addEventListener("click", function() {
      frameSlideshow.next();
    });

    let prevArrow = frameSlideshowEl.querySelector(".arrow.previous");
    prevArrow.addEventListener("click", function() {
      frameSlideshow.previous();
    });
    */

    // check for embed slide, replace default pager dot with SVG
    let embedSlide = frameSlideshowEl.querySelector(".slide.embed");
    if (typeof embedSlide != "undefined" && embedSlide != null) {
      // get index of embedSlide
      let embedSlideIndex = frameSlideshow
        .getCellElements()
        .indexOf(embedSlide);
      // get pager dots
      let pagerDots = frameSlideshowEl.querySelector(".flickity-page-dots");
      // get pager dots array
      let pagerDotsArray = Array.from(pagerDots.children);
      // get embed dot
      let embedDot = pagerDotsArray[embedSlideIndex];
      embedDot.setAttribute("data-icon", "yes");
    }
  });

  let vtoBtn = document.querySelector(".vto_mark");
  if (typeof vtoBtn != "undefined" && vtoBtn != null) {
    vtoBtn.addEventListener("click", function () {
      // need to get the active cell based on having class of entered but not exited
      let activeCell = document.querySelector(".cell.entered:not(.exited)");
      let activeCellId = activeCell
        .querySelector(".frame_slideshow")
        .getAttribute("data-id");
      let targetSlideshow = document.querySelector(
        ".frame_slideshow[data-id='" + activeCellId + "']"
      );
      let targetDots = targetSlideshow.querySelectorAll(
        ".flickity-page-dots .dot"
      );

      // clicking on the VTO goes directly to the 360 overlay
      let targetSlide = targetSlideshow.querySelector(".slide.embed");
      let targetLink = targetSlide.getAttribute("data-link");
      window.location.href = targetLink;

      // scroll to 360 frame
      /*

      // target the last dot
      let targetDot = targetDots[targetDots.length - 1];
      targetDot.click();
      */
    });
  }

  /* DETAIL PAGE STAGE FRAME SLIDESHOWS */
  let frameStageSlideshowEls = document.querySelectorAll(
    ".frame_thumbs .thumbs_slideshow"
  );
  frameStageSlideshowEls.forEach((frameStageSlideshowEl) => {
    let frameStageSlideshow = new Flickity(frameStageSlideshowEl, {
      // options
      cellSelector: ".cell",
      fade: false,
      cellAlign: "left",
      wrapAround: false,
      pageDots: false,
      prevNextButtons: true,
      draggable: false,
    });
  });

  /* COLLECTIONS PAGE FRAME SLIDESHOWS */

  /*  
  let slideshowEls = document.querySelectorAll(".cell .slideshow");
    slideshowEls.forEach(slideshowEl => {

      let flkty = new Flickity(slideshowEl, {
        // options
        fade: false,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: 1200,
        pauseAutoPlayOnHover: false,
        draggable: false,
      });

      flkty.stopPlayer();

      // hover event loads slide images and starts player
      slideshowEl.addEventListener("mouseenter", function() {
        let slideImages = slideshowEl.querySelectorAll("img.photo");
        slideImages.forEach(slideImage => {
          loadImage(slideImage);
        });
        flkty.playPlayer();
      });

      // mouse out stops player
      slideshowEl.addEventListener("mouseleave", function() {
        flkty.stopPlayer();
      });

    });
    */

  /* homepage slideshow */

  /* 
    let slideshowEl = document.querySelector(".home .slideshow");
    
  
    if (typeof slideshowEl != "undefined" && slideshowEl != null) {
      let flkty = new Flickity(slideshowEl, {
        // options
        fade: true,
        cellSelector: ".cell",
      });
  
      // change event
      flkty.on("change", function (index) {
        let slideCount = index + 1;
        counterEl.innerHTML = slideCount;
      });
    }
    */

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  //function from gsap for horizontal loop
  function horizontalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};
    let tl = gsap.timeline({
        repeat: config.repeat,
        paused: config.paused,
        defaults: { ease: "none" },
        onReverseComplete: () =>
          tl.totalTime(tl.rawTime() + tl.duration() * 100),
      }),
      length = items.length,
      startX = items[0].offsetLeft,
      times = [],
      widths = [],
      xPercents = [],
      curIndex = 0,
      pixelsPerSecond = (config.speed || 1) * 100,
      snap =
        config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
      totalWidth,
      curX,
      distanceToStart,
      distanceToLoop,
      item,
      i;
    gsap.set(items, {
      // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
      xPercent: (i, el) => {
        let w = (widths[i] = parseFloat(gsap.getProperty(el, "width", "px")));
        xPercents[i] = snap(
          (parseFloat(gsap.getProperty(el, "x", "px")) / w) * 100 +
            gsap.getProperty(el, "xPercent")
        );
        return xPercents[i];
      },
    });
    gsap.set(items, { x: 0 });
    totalWidth =
      items[length - 1].offsetLeft +
      (xPercents[length - 1] / 100) * widths[length - 1] -
      startX +
      items[length - 1].offsetWidth *
        gsap.getProperty(items[length - 1], "scaleX") +
      (parseFloat(config.paddingRight) || 0);
    for (i = 0; i < length; i++) {
      item = items[i];
      curX = (xPercents[i] / 100) * widths[i];
      distanceToStart = item.offsetLeft + curX - startX;
      distanceToLoop =
        distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
      tl.to(
        item,
        {
          xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
          duration: distanceToLoop / pixelsPerSecond,
        },
        0
      )
        .fromTo(
          item,
          {
            xPercent: snap(
              ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
            ),
          },
          {
            xPercent: xPercents[i],
            duration:
              (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
            immediateRender: false,
          },
          distanceToLoop / pixelsPerSecond
        )
        .add("label" + i, distanceToStart / pixelsPerSecond);
      times[i] = distanceToStart / pixelsPerSecond;
    }
    function toIndex(index, vars) {
      vars = vars || {};
      Math.abs(index - curIndex) > length / 2 &&
        (index += index > curIndex ? -length : length); // always go in the shortest direction
      let newIndex = gsap.utils.wrap(0, length, index),
        time = times[newIndex];
      if (time > tl.time() !== index > curIndex) {
        // if we're wrapping the timeline's playhead, make the proper adjustments
        vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
        time += tl.duration() * (index > curIndex ? 1 : -1);
      }
      curIndex = newIndex;
      vars.overwrite = true;
      return tl.tweenTo(time, vars);
    }
    tl.next = (vars) => toIndex(curIndex + 1, vars);
    tl.previous = (vars) => toIndex(curIndex - 1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
      tl.vars.onReverseComplete();
      tl.reverse();
    }
    return tl;
  }

  function createCols() {
    // takes items from the #library div and places them in order in 3 cols for desktop, 1 col for mobile
    let colCount = 3;
    let itemCount = 1;
    let scrollCols = document.querySelector(".scroll_cols");
    if (window.innerWidth <= 1023) {
      colCount = 1;
    }
    let items = library.querySelectorAll(".cell");
    items.forEach((item) => {
      // append item into col
      scrollCols.querySelector(".col" + itemCount).appendChild(item);
      ++itemCount;
      if (itemCount == 4) {
        itemCount = 1;
      }
    });

    // after cols are built update scroller object
    setTimeout(function () {
      scroller.resizeRequest = 1;
      updateScroller();
    }, 50);

    // trigger deleted inview loading of images for smoother page load
    setTimeout(function () {
      loadDelayInit();
    }, 100);
  }

  function loadImage(image) {
    if (!image) {
      return;
    }

    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (image.classList.contains("loaded")) {
      return;
    }

    const serverPath = "https://www.laeyeworks.com/images/pics/";
    //const serverPath = "/images/pics/";

    if (!image.classList.contains("gif")) {
      /*
      if (newW <= 500) {
        imgpath = serverPath + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = serverPath + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = serverPath + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = serverPath + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = serverPath + img;
      } else {
        imgpath = serverPath + img;
      }
      */

      imgpath = serverPath + img;
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = serverPath + img;
      fullpath = serverPath + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
      let imageCell = image.closest(".cell");
      if (typeof imageCell != "undefined" && imageCell != null) {
        image.closest(".cell").classList.add("ready");
      }
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  function openOverlay() {
    overlayFull.classList.add("on");
  }

  function closeOverlay() {
    if (typeof overlay != "undefined" && overlay != null) {
      overlay.classList.remove("ON");
    }
    if (typeof overlayFull != "undefined" && overlayFull != null) {
      overlayFull.classList.remove("on");
    }
    overlayInner.innerHTML = "";
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {
    // handle resizing of AR Rows
    let arRowsCell = document.querySelectorAll(".ar-rows .row .cell");
    for (let i = 0; i < arRowsCell.length; ++i) {
      var _this = arRowsCell[i],
        container = _this.closest(".ar-rows"),
        rowsMargin = container.getAttribute("data-margin"),
        percW = _this.getAttribute("data-percW"),
        percH = _this.getAttribute("data-percH"),
        ratio = _this.getAttribute("data-ratio"),
        num = _this.getAttribute("data-numImages"),
        containerWidth = container.offsetWidth - rowsMargin * (num - 1);

      _this.style.width = containerWidth * percW + "px";
      let cellImg = _this.querySelector("img");
      cellImg.style.height = ratio * (containerWidth * percW) + "px";
    }
  }

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // COLLECTION PAGE FILTERS
  let filterEl = document.getElementById("filters");
  if (typeof filterEl != "undefined" && filterEl != null) {
    // setup options arrays, need to start with values found in hidden inputs
    let colorArray = document.getElementById("filter_color").value.split("-");
    let shapeArray = document.getElementById("filter_shape").value.split("-");
    let sizeArray = document.getElementById("filter_size").value.split("-");

    // handle clear all click
    let clearBtn = filterEl.querySelector(".clearFilters a");
    clearBtn.addEventListener("click", function (e) {
      e.preventDefault();
      let options = filterEl.querySelectorAll("ul li span");
      options.forEach((option) => {
        option.classList.remove("active");
      });
      // clear hidden inputs
      document.getElementById("filter_color").value = "";
      document.getElementById("filter_shape").value = "";
      document.getElementById("filter_size").value = "";
    });

    // handle filter options click
    let options = filterEl.querySelectorAll("ul li span");
    options.forEach((option) => {
      option.addEventListener("click", function (e) {
        e.preventDefault();
        let id = option.getAttribute("data-filter");
        let type = option.getAttribute("data-type");
        option.classList.toggle("active");
        if (option.classList.contains("active")) {
          if (type === "color") {
            colorArray.push(id);
          }
          if (type === "shape") {
            shapeArray.push(id);
          }
          if (type === "size") {
            sizeArray.push(id);
          }
        } else {
          if (type === "color") {
            colorArray = colorArray.filter((item) => item !== id);
          }
          if (type === "shape") {
            shapeArray = shapeArray.filter((item) => item !== id);
          }
          if (type === "size") {
            sizeArray = sizeArray.filter((item) => item !== id);
          }
        }

        // convert the array to a string and update filter hidden input
        let optionString;
        if (type === "color") {
          optionString = colorArray.join("-");
        }
        if (type === "shape") {
          optionString = shapeArray.join("-");
        }
        if (type === "size") {
          optionString = sizeArray.join("-");
        }
        let optionInput = document.getElementById("filter_" + type);
        optionInput.value = optionString;

        // remove leading "-" character
        if (optionInput.value.charAt(0) === "-") {
          optionInput.value = optionInput.value.slice(1);
        }
      });
    });

    // handle form submit button
    let filterForm = document.getElementById("filter_form");
    let filterBtn = document.getElementById("filterBtn");

    filterBtn.addEventListener("click", function (e) {
      e.preventDefault();
      filterForm.submit();
    });
  }

  // OVERLAY CLICKS
  let overlayLinks = document.querySelectorAll(".openOverlay");
  overlayLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getItem.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        openOverlay();
      });
    });
  });

  // close overlay
  if (typeof overlayCloser != "undefined" && overlayCloser != null) {
    overlayCloser.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        closeOverlay();
      },
      true
    );
  }

  // SCROLL ARROW CLICKS
  let scrollArrowEls = document.querySelectorAll(".scrollTease");
  scrollArrowEls.forEach((scrollArrowEl) => {
    scrollArrowEl.addEventListener("click", function (e) {
      e.preventDefault();
      // find next section and scroll to that
      let targetSelector = scrollArrowEl.getAttribute("data-target");
      let targetEl = document.querySelector("." + targetSelector);
      zenscroll.to(targetEl);
    });
  });

  // COLLECTIONS FILTER
  let filterTrigger = document.querySelector(".filter .trigger");
  if (typeof filterTrigger != "undefined" && filterTrigger != null) {
    filterTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      let filterParent = document.querySelector(".filter");
      let filter = document.querySelector("#filters");
      let filterContents = filter.querySelector(".inner");
      if (filterParent.classList.contains("open")) {
        // set the height to 0 and remove open class
        filter.style.height = "0px";
        filterParent.classList.remove("open");
      } else {
        filter.style.height = filterContents.offsetHeight + "px";
        filterParent.classList.add("open");
      }
    });
  }

  // COLLECTIONS SORT
  let collectionSortTrigger = document.querySelector("#filter .sort .trigger");
  if (
    typeof collectionSortTrigger != "undefined" &&
    collectionSortTrigger != null
  ) {
    collectionSortTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      let collectionSort = document.querySelector("#filter .sort");
      if (collectionSort.classList.contains("open")) {
        collectionSort.classList.remove("open");
      } else {
        collectionSort.classList.add("open");
      }
    });
  }

  let collectionSortOptions = document.querySelectorAll("#sortOptions li");
  collectionSortOptions.forEach((collectionSortOption) => {
    collectionSortOption.addEventListener("click", function (e) {
      e.preventDefault();
      let collectionSlug = document
        .querySelector("#filter")
        .getAttribute("data-slug");
      let collectionUrl = "/collections/" + collectionSlug;
      let sortValue = collectionSortOption.getAttribute("data-filter");
      window.location.href = collectionUrl + "?sort=" + sortValue;
    });
  });

  // COLLECTIONS SEARCH OVERLAY
  let collectionSearchTrigger = document.querySelector("#filter .search");
  if (
    typeof collectionSearchTrigger != "undefined" &&
    collectionSearchTrigger != null
  ) {
    let searchOverlayEl = document.getElementById("search_overlay");
    let searchField = searchOverlayEl.querySelector("input");
    collectionSearchTrigger.addEventListener("click", function (e) {
      e.preventDefault();
      if (searchOverlayEl.classList.contains("active")) {
        body.classList.remove("search_on");
        searchOverlayEl.classList.remove("active");
        searchField.blur();
        setTimeout(function () {
          searchField.value = "";
        }, 501);
      } else {
        body.classList.add("search_on");
        searchOverlayEl.classList.add("active");
        searchField.focus();
      }
    });
  }

  // WHERE TO BUY FORM
  let wtbForm = document.getElementById("wtb_form");
  if (typeof wtbForm != "undefined" && wtbForm != null) {
    let searchResultsEl = document.getElementById("searchResults");

    wtbForm.addEventListener("submit", function (e) {
      e.preventDefault();
      let country = wtbForm.querySelector("#country").value;
      let zip = wtbForm.querySelector("#zip").value;
      getAjax(
        "/retailerList.php?country=" + country + "&zip=" + zip,
        function (data) {
          body.classList.add("wtb_results");
          searchResultsEl.innerHTML = data;
        }
      );
    });
  }

  // ECOM EVENTS BEGIN

  let closeOverlayBtns = document.querySelectorAll(".closeOverlay");
  closeOverlayBtns.forEach((closeoverlayBtn) => {
    closeoverlayBtn.addEventListener("click", function (e) {
      e.preventDefault();
      closeOverlay();
    });
  });

  // update cart qty
  let updateCartQtyBtns = document.querySelectorAll(".update_cart_qty");
  updateCartQtyBtns.forEach((updateCartQtyBtn) => {
    updateCartQtyBtn.addEventListener("change", function (e) {
      let cartID = updateCartQtyBtn.getAttribute("data-cartid");
      let qty = updateCartQtyBtn.value;

      dataString = "cartID=" + cartID + "&qty=" + qty;

      getAjax("/classes/updateQuantity.php?" + dataString, function (data) {
        window.location.reload();
      });
    });
  });

  // remove from cart click
  let removeFromCartBtns = document.querySelectorAll(".remove_from_cart");
  removeFromCartBtns.forEach((removeFromCartBtn) => {
    removeFromCartBtn.addEventListener("click", function (e) {
      e.preventDefault();

      let cartID = removeFromCartBtn.getAttribute("data-cartid");
      let dataString = "cartID=" + cartID;

      getAjax("/classes/removeFromCart.php?" + dataString, function (data) {
        location.reload();
        /*
        let removeCell = document.querySelector(".cart .cell[data-cartid='"+cartID+"']");
        removeCell.parentNode.removeChild(removeCell);
        */
      });
    });
  });

  // add to cart click
  let addToCartBtns = document.querySelectorAll(".btn.addToCart");
  addToCartBtns.forEach((addToCartBtn) => {
    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      let itemForm = addToCartBtn.closest("form");
      let prodID = itemForm.querySelector("input[name='prodID']").value;
      let qty = itemForm.querySelector("input[name='qty']").value;
      let option = itemForm.querySelector("input[name='optionID']").value;
      let itemNo = itemForm.querySelector("input[name='itemNo']").value;

      let dataString =
        "prodID=" +
        prodID +
        "&qty=" +
        qty +
        "&optionStr=" +
        option +
        "&itemNo=" +
        itemNo;

      getAjax("/classes/addToCart.php?" + dataString, function (data) {
        overlay.classList.add("ON");
      });
    });
  });

  /*

  $(".addToCart").click(function() {

		var theParent = $(this).parent();

		var prodID = theParent.find("input.prodID").val();
		var qty = parseInt(theParent.find("input.qty").val());
		var option = parseInt(theParent.find("input.optionID").val());
		var itemNo = theParent.find("input.itemNo").val();
		var itemCount = parseInt(theParent.find(".cartCount").html());

		var dataString = 'prodID=' + prodID + '&qty=' + qty + '&optionStr=' + option + "&itemNo=" + itemNo;

		$.ajax({
			type: "POST",
			url: "/classes/addToCart.php",
			data: dataString,
			success: function() {

				//$(".navHolder").load('/includes/nav.php?added=yes');
				$('#overlay').addClass('ON');
				$('nav li.carticon').show();

			}
		});
		return false;

	});

  */

  // ECOM EVENTS END

  // LISTEN FOR TAB EVENT, IF FOUND, DISABLE GSAP SCROLL FOR ACCESSBILITY AND FOCUS
  document.addEventListener("keydown", logKey);

  function logKey(e) {
    if (e.code === "Tab") {
      killScroller();
      container.classList.add("off");
      scrollContainer.classList.add("off");
    }
  }

  // frame detail page more info hover
  let moreInfo = document.querySelector(".more_info");
  if (typeof moreInfo != "undefined" && moreInfo != null) {
    let moreInfoTrigger = moreInfo.querySelector(".more_info .label");
    moreInfoTrigger.addEventListener("mouseenter", function () {
      moreInfo.classList.add("open");
    });
    moreInfo.addEventListener("mouseleave", function () {
      moreInfo.classList.remove("open");
    });
  }

  // frame detail page thumbnail click
  frameThumbs.forEach((frameThumb) => {
    frameThumb.addEventListener("click", function (e) {
      let color = this.getAttribute("data-color");
      let targetFrameEl = document.querySelector(
        ".detailwrap .frames .cell[data-color='" + color + "']"
      );
      zenscroll.center(targetFrameEl);
    });
  });

  // collection FILTER functions

  let filter = document.getElementById("filter");
  if (typeof filter != "undefined" && filter != null) {
    let frontSlideshows = document.querySelectorAll(".cell .slideshow.front");
    let sideSlideshows = document.querySelectorAll(".cell .slideshow.side");

    // handle front / side views
    let imageViewBtns = filter.querySelectorAll(".views .view");
    let imageViewImgs = filter.querySelectorAll(".views img");

    function removeViewActive() {
      imageViewImgs.forEach((imageViewImg) => {
        imageViewImg.classList.remove("active");
      });
    }

    function makeViewActive(view) {
      // view is the user selected image
      if (view === "front") {
        frontSlideshows.forEach((slideshow) => {
          slideshow.classList.add("active");
        });
        sideSlideshows.forEach((slideshow) => {
          slideshow.classList.remove("active");
        });
        filter
          .querySelector(".views .view[data-view='front']")
          .querySelector("img.on")
          .classList.add("active");
        filter
          .querySelector(".views .view[data-view='side']")
          .querySelector("img.off")
          .classList.add("active");
      } else {
        frontSlideshows.forEach((slideshow) => {
          slideshow.classList.remove("active");
        });
        sideSlideshows.forEach((slideshow) => {
          let sideImg = slideshow.querySelector("img.photo");
          sideImg.classList.add("loadmeview");
          slideshow.classList.add("active");
        });

        loadImageInit();

        filter
          .querySelector(".views .view[data-view='front']")
          .querySelector("img.off")
          .classList.add("active");
        filter
          .querySelector(".views .view[data-view='side']")
          .querySelector("img.on")
          .classList.add("active");
      }
    }

    imageViewBtns.forEach((imageViewBtn) => {
      imageViewBtn.addEventListener("click", () => {
        let view = imageViewBtn.getAttribute("data-view");
        removeViewActive();
        makeViewActive(view);
        loadImageInit();
      });
    });
  }

  // scroll cols column transform

  /*
  let transformCol = document.querySelector(".scroll_cols .col2");
  gsap.to(transformCol, {
    scrollTrigger: {
      trigger: body,
      start: "top top",
      end: "bottom top",
      scrub: true,
      markers: false,
    },
    y: '-1100px', // this number should be a % of document height or something related to length of grid TODO
  });
  */

  //hover cells hover effect
  let scrollCells = document.querySelectorAll(".hoverCell");

  for (let i = 0; i < scrollCells.length; i++) {
    scrollCells[i].addEventListener("mouseenter", function (event) {
      event.preventDefault(), this.classList.add("hovered");
    }),
      scrollCells[i].addEventListener("mouseleave", function (event) {
        event.preventDefault(), this.classList.remove("hovered");
      });
  }

  //Roster hover events that display media
  function removeRosterState() {
    let rosterCells = document.querySelectorAll(".roster_hover .cell");
    rosterCells.forEach((rosterCell) => {
      rosterCell.classList.remove("active");
    });
    let rosterNames = document.querySelectorAll(".roster_hover h2");
    rosterNames.forEach((rosterName) => {
      rosterName.classList.remove("active");
    });
  }

  let rosterLinks = document.querySelectorAll(".roster_hover a");
  rosterLinks.forEach((rosterLink) => {
    hoverintent(
      rosterLink,
      function (e) {
        e.preventDefault();
        // get the height of the content element
        let contentEl = rosterLink.querySelector(".content");
        let contentH = 0;
        if (typeof contentEl != "undefined" && contentEl != null) {
          contentH = contentEl.querySelector(".content p").offsetHeight;
        }
        // get the id
        let id = rosterLink.getAttribute("data-id");
        removeRosterState();
        // target roster cell with matching ID
        let activeCell = document.querySelector(
          ".roster_hover .cell[data-id='" + id + "']"
        );

        // check for video content
        let nextVideoEl = activeCell.querySelector("video");
        if (typeof nextVideoEl != "undefined" && nextVideoEl != null) {
          nextVideoEl.play();
        }
        activeCell.classList.add("active");
        if (rosterLink.classList.contains("open")) {
          rosterLink.classList.remove("open");
          if (typeof contentEl != "undefined" && contentEl != null) {
            contentEl.style.height = "0px";
          }
        } else {
          rosterLink.classList.add("open");
          if (typeof contentEl != "undefined" && contentEl != null) {
            contentEl.style.height = contentH + "px";
          }
        }
      },
      function (e) {
        e.preventDefault();
        let id = rosterLink.getAttribute("data-id");
        // target roster cell with matching ID

        // remove link class
        rosterLink.classList.remove("open");

        // close content element
        let contentEl = rosterLink.querySelector(".content");
        if (typeof contentEl != "undefined" && contentEl != null) {
          contentEl.style.height = "0px";
        }

        let activeCell = document.querySelector(
          ".roster_hover .cell[data-id='" + id + "']"
        );
        activeCell.classList.remove("active");
      }
    );
  });

  //hamburger menu toggle
  menuBtn.addEventListener(
    "click",
    function (event) {
      event.preventDefault(), document.body.classList.toggle("menuOn");
    },
    true
  );

  menuBtn.addEventListener(
    "keydown",
    function (event) {
      event.preventDefault();
      if (event.code === "Enter") {
        document.body.classList.toggle("menuOn");
      }
    },
    true
  );

  // HEADER change on scroll up/down
  var scrollPosition = window.pageYOffset;

  window.addEventListener(
    "scroll",
    function () {
      scrollPosition = window.pageYOffset;

      if (scrollPosition > 10) {
        body.classList.add("scrolled");
      } else {
        body.classList.remove("scrolled"), body.classList.remove("menuOn");
      }

      //lastScrollTop = st;
    },
    false
  );

  // DRAWER CLICKS =================

  let drawerBtns = document.querySelectorAll(".drawer-title");
  drawerBtns.forEach((drawerBtn) => {
    drawerBtn.addEventListener("click", drawerToggle);
  });

  function drawerToggle() {
    let drawer = this.closest(".drawer"),
      reveal = drawer.querySelector(".reveal"),
      revealH = 0,
      wrapper = drawer.querySelector(".wrapper");

    if (reveal.classList.contains("open")) {
      revealH = 0;
    } else {
      revealH = wrapper.offsetHeight;
    }
    reveal.style.height = revealH + "px";
    reveal.classList.toggle("open");
  }

  // CUSTOM CURSOR ==================================

  // cursor vars
  const cursor = document.getElementById("frame_cursor");
  let location = {};
  let adjY, adjX;

  const cursorParentElement = document.querySelector(".frame_slideshow");

  let frameSlideshowSlides = document.querySelectorAll(
    ".detailpage .frame_slideshow .slide:not(.embed)"
  );
  frameSlideshowSlides.forEach((frameSlideshowSlide) => {
    frameSlideshowSlide.addEventListener("mousemove", mousemove);
    frameSlideshowSlide.addEventListener("mouseleave", mouseleave);
    frameSlideshowSlide.addEventListener("click", function (e) {
      e.preventDefault();
      // get current index of slide clicked
      let frameSlideshow = frameSlideshowSlide.closest(".frame_slideshow");
      let frameSlideshowSlides = frameSlideshow.querySelectorAll(".slide");
      let slideIndex =
        Array.from(frameSlideshowSlides).indexOf(frameSlideshowSlide);

      let frameSlideshowDots = frameSlideshow.querySelectorAll(".dot");

      // if they clicked on the left side of the slide go to previous slide, if not go to next slide
      let parentWidth = frameSlideshowSlide.offsetWidth;
      let parentCenter = parentWidth / 2;
      let targetDot;
      if (location.relativeX > parentCenter) {
        // go to next slide
        targetDot = frameSlideshowDots[slideIndex + 1];
        if (targetDot == null || typeof targetDot == "undefined") {
          targetDot = frameSlideshowDots[0];
        }
      } else {
        // go to previous slide
        targetDot = frameSlideshowDots[slideIndex - 1];
        if (targetDot == null || typeof targetDot == "undefined") {
          // get last dot
          targetDot = frameSlideshowDots[frameSlideshowDots.length - 1];
        }
      }
      targetDot.click();
    });
  });

  function mousemove(e) {
    location.x = e.clientX;

    // Get the X position of the parent element relative to the window
    const parentRect = cursorParentElement.getBoundingClientRect();
    const parentX = parentRect.left;

    // Calculate the X position of the mouse relative to the parent element
    const relativeX = location.x - parentX;

    location.relativeX = relativeX;
    location.y = e.clientY;

    cursor.style.opacity = 1;

    window.requestAnimationFrame(function () {
      positionCursor(location, cursor);
    });
  }

  function mouseleave() {
    cursor.style.opacity = 0;
  }

  function positionCursor(loc, element) {
    // need to update the offsets based on state of cursor
    adjY = 15;
    adjX = 15;
    element.style.top = loc.y - adjY + "px";
    element.style.left = loc.x - adjX + "px";

    let frameSlideshowEl = document.querySelector(".frame_slideshow");
    // need to check if we are over the left or right side of the element
    let parentWidth = frameSlideshowEl.offsetWidth;
    let parentCenter = parentWidth / 2;
    if (loc.relativeX > parentCenter) {
      element.classList.add("right");
    } else {
      element.classList.remove("right");
    }
  }
});
